import React from 'react';
import { Outlet } from 'react-router-dom';
import { Header } from '../shared/Header';
import { Footer } from '../shared/Footer';
import { MobileNav } from '../shared/MobileNav';
export const PublicLayout = () => {
  return <div className="min-h-screen bg-neutral-light lg:pb-6" data-id="element-149">
      <div className="max-w-screen-2xl mx-auto bg-white lg:rounded-3xl lg:shadow-2xl flex flex-col min-h-[calc(100vh-3rem)]" data-id="element-150">
        <Header data-id="element-151" />
        <main className="flex-grow pb-28 md:pb-0" data-id="element-152">
          <Outlet data-id="element-153" />
        </main>
        <Footer data-id="element-154" />
      </div>
      <MobileNav data-id="element-155" />
    </div>;
};